import { useEffect, useRef } from 'react';
import { useLocationSearchParameters } from 'utils/hooks/useLocationSearchParameters';
import { ARTICLE_IN_IFRAME_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import { ArticleInIframe } from 'components/ArticleInIframe';
import { useUpdateLocationSearchParameters } from 'utils/hooks/useUpdateLocationSearchParameters';

// DEV-3255
export const useArticleInIframe = () => {
  const closeIframeRef = useRef(null);
  const { [ARTICLE_IN_IFRAME_URL_SEARCH_PARAM]: iframeSearchParam } = useLocationSearchParameters();
  const replaceLocationSearchParameters = useUpdateLocationSearchParameters({ isPushMethod: false });

  // did mount only
  useEffect(() => {
    if (!iframeSearchParam) {
      return;
    }
    const iframe = new ArticleInIframe();
    iframe.show({
      src: decodeURIComponent(iframeSearchParam),
      onClose: () => {
        closeIframeRef.current = null;
        replaceLocationSearchParameters({ [ARTICLE_IN_IFRAME_URL_SEARCH_PARAM]: null });
      },
    });
    closeIframeRef.current = () => {
      iframe.hide();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { current: closeIframe } = closeIframeRef;
    if (iframeSearchParam || !closeIframe) {
      return;
    }
    closeIframeRef.current = null;
    closeIframe();
    replaceLocationSearchParameters({ [ARTICLE_IN_IFRAME_URL_SEARCH_PARAM]: null });
  }, [iframeSearchParam, replaceLocationSearchParameters]);
};
